import React from 'react';
import { WidgetProps } from '@rjsf/core';
import { Form } from 'semantic-ui-react'
import { useSchemaTranslation } from '../../../useSchemaTranslation';

const RadioWidget = ({
  id,
  schema,
  options,
  value,
  required,
  disabled,
  readonly,
  label,
  onChange,
  onBlur,
  onFocus,
}: WidgetProps) => {
  const { t } = useSchemaTranslation();
  // Generating a unique field name to identify this set of radio buttons
  const name = Math.random().toString();
  const { enumOptions, enumDisabled, semanticProps = {} } = options;


  const inline = Boolean(options.inline)

  return (
    <Form.Group className="field-radio-group" inline={inline} grouped={!inline}>
      {(enumOptions as any).map((option: any, i: number) => {
        const checked = option.value === value;
        const itemDisabled = enumDisabled && (enumDisabled as any).indexOf(option.value) != -1; // eslint-disable-line

        return (
          <Form.Radio
            key={i}
            name={name}
            label={t(`${option.label}`)}
            value={`${option.value}`}
            disabled={disabled || itemDisabled || readonly}
            checked={checked}
            onChange={_ => onChange(option.value)}
            onBlur={onBlur && ((event: any) => onBlur(id, event.target.value))}
            onFocus={onFocus && ((event: any) => onFocus(id, event.target.value))}
            {...semanticProps}
          />
        )
      })}
    </Form.Group>
  );
};

export default RadioWidget;
